export function getRequestID(): string {
  try {
    // Modern browser UUID generator
    // const requestId: string = crypto.randomUUID();
    const requestId: string = (crypto as any).randomUUID();

    console.log("Request ID:", requestId);

    return requestId;
  } catch (error) {
    // Fallback for older browsers
    const requestId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;

        return v.toString(16);
      }
    );

    console.log("Fallback Request ID:", requestId);

    return requestId;
  }
}
